window.mmajaxcart = {
    AjaxcartOpen: function() {
        var body = $('body'),
            ajaxCart = $('.mm-ajaxcart'),
            ajaxOverlay = $('.mm-ajaxcart-overlay');
        body.addClass('mm-no-scroll');
        ajaxCart.addClass('has--opened');
        ajaxOverlay.addClass('has--active')
    },
    AjaxcartClose: function() {
        var body = $('body'),
            ajaxCart = $('.mm-ajaxcart'),
            ajaxOverlay = $('.mm-ajaxcart-overlay');
        body.removeClass('mm-no-scroll');
        ajaxCart.removeClass('has--opened');
        ajaxOverlay.removeClass('has--active')
    },
    AjaxcartRender: function() {
        $.get('/cart?view=mm-ajax', function(cart) {
            $('.mm-ajaxcart').html(cart);
            const parser = new DOMParser();
            const cartHTML = parser.parseFromString(cart, 'text/html');
            const cartCount = cartHTML.querySelector('.mm-ajaxcart-header p').innerText.match(/\((\d+)\)/)?.[1]
            document.querySelectorAll('.header-cart__count').forEach(elem => elem.innerText = cartCount)
            mmajaxcart.loyalty_point()
        })
        progressBar()
    },
    AjaxcartChangeHandler: function(data) {
        $.ajax({
            url: '/cart/change.js',
            dataType: 'json',
            cache: !1,
            type: 'post',
            data: data,
            success: function(cart) {
                mmajaxcart.AjaxcartRender();
                mmajaxcart.loyalty_point();
                let CartCount = cart.item_count;
                document.querySelectorAll('.header-cart__count').forEach((elem) => {
                    elem.innerText = cart.item_count
                })
                $('.mm-cart-count').html(CartCount)
            }
        })
    },
    AjaxcartUpdateHandler: function(data) {
        let formData = {
            updates: data
        };
        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        }).then(response => {
            return response.json()
        }).then(cart => {
            mmajaxcart.AjaxcartRender();
            mmajaxcart.loyalty_point();
            let CartCount = cart.item_count;
            document.querySelectorAll('.header-cart__count').forEach((elem) => {
                elem.innerText = cart.item_count
            })
            $('.mm-cart-count').html(CartCount)
        }).catch((error) => {
            console.error('Error:', error)
        })
    },
    AjaxcartQuantityHandler: function() {
        function updateQuantity(elem) {
            debugger
            var UpdatedQuantity = parseInt($(elem).val()),
                QuantityLine = parseInt($(elem).attr('data-line')),
                params = {
                    quantity: UpdatedQuantity,
                    line: QuantityLine
                };
            let parent = elem.closest("[data-custom-product]")
            let customProductQnty = UpdatedQuantity;
            if (elem.closest("[data-custom-product]")) {
                document.querySelectorAll("[data-custom-product]").forEach((ele) => {
                    if (ele != parent[0]) {
                        customProductQnty = customProductQnty + parseInt(ele.dataset.quantity)
                    }
                })
                params = {};
                let parentKey = $(elem).attr('data-key')
                let addOnKey = document.querySelector("[data-addOnproduct]")
                params[parentKey] = UpdatedQuantity
                if (addOnKey) {
                    addOnKey = addOnKey.dataset.key
                    params[addOnKey] = customProductQnty
                };
                mmajaxcart.AjaxcartUpdateHandler(params)
            } else {
                mmajaxcart.AjaxcartChangeHandler(params)
            }
            mmajaxcart.loyalty_point()
        }
        $(document).on('change', '.quantity-input', function() {
            updateQuantity($(this).parent().find('.quantity-input'))
        })
        $(document).on('click', '.quantity-plus', function() {
            let q = $(this).parent().find('.quantity-input').val(),
                i = 1,
                p = parseInt(i),
                u = parseInt(q) + p;
            $(this).parent().find('.quantity-input').val(u)
            updateQuantity($(this).parent().find('.quantity-input'))
        })
        $(document).on('click', '.quantity-minus', function() {
            let q = $(this).parent().find('.quantity-input').val(),
                i = 1,
                p = parseInt(i),
                u = parseInt(q) - p;
            $(this).parent().find('.quantity-input').val(u)
            updateQuantity($(this).parent().find('.quantity-input'))
            mmajaxcart.loyalty_point()
        })
    },
    AjaxcartRemoveItem: function() {
        $(document).on('click', '.mm-ajaxcart-remove-item', function() {
            var RemoveLine = parseInt($(this).attr('data-line')),
                params = {
                    quantity: 0,
                    line: RemoveLine
                };
            let parent = this.closest("[data-custom-product]")
            if (parent && parent.hasAttribute('data-custom-product')) {
                let UpdatedQuantity = parseInt(parent.querySelector('input').value)
                let customProductQnty = 0;
                if (parent) {
                    document.querySelectorAll("[data-custom-product]").forEach((ele) => {
                        if (ele != parent) {
                            customProductQnty = customProductQnty + parseInt(ele.dataset.quantity)
                        }
                    })
                    params = {};
                    let parentKey = parent.dataset.key
                    let addOnKey = document.querySelector("[data-addOnproduct]")
                    params[parentKey] = 0
                    if (addOnKey) {
                        addOnKey = addOnKey.dataset.key
                        params[addOnKey] = customProductQnty
                    };
                    mmajaxcart.AjaxcartUpdateHandler(params)
                }
            }
            mmajaxcart.AjaxcartChangeHandler(params)
        })
    },
    Ajaxupsell: function() {
        $(document).on('click', '.add-to-cart', function() {
            var variantId = $(this).attr('data-variantids')
            console.log(variantId);
            var data = {
                id: variantId,
                quantity: 1
            };
            fetch('/cart/add.js', {
                body: JSON.stringify(data),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'POST'
            }).then(function(response) {
                return response.json()
            }).then(function(json) {
                mmajaxcart.AjaxcartOpen();
                mmajaxcart.AjaxcartRender()
            }).catch(function(err) {
                console.error(err)
            })
        })
    },
    loyalty_point: function() {
        const item_value = jQuery('.mm-ajaxcart-items li.ajaxcartItem').length;
        const name = localStorage.getItem('loyalty');
        if (localStorage.getItem('loyalty') != null) {
            var data_id = localStorage.getItem('loyalty');
            if (item_value > 0) {
                var data = {
                    "data_id": data_id,
                    "method_call": "get_load_points"
                }
            } else {
                var data = {
                    "data_id": data_id,
                    "method_call": "cart_empty_remove_point"
                }
            }
            jQuery.ajax({
                "url": "http://app.miarcus.com/loyalty/loyalty.php",
                "type": "post",
                "data": data,
                "success": function(value) {
                    var obj = jQuery.parseJSON(value);
                    var d = atob(obj.value);
                    var test = d.split("--");
                    var q = atob(test[0])
                    if (obj.success === !0 && obj.status === "loyalty_show") {
                        setTimeout(function() {
                            jQuery('.error_point').html("");
                            jQuery('.l_wrap').html(obj.msg);
                            jQuery('.l_point_wrap').html(obj.msg_value);
                            var check_local = localStorage.getItem("loyalty");
                            if (check_local === null) {
                                localStorage.setItem("loyalty", data_id)
                            }
                            jQuery('.docapp-coupon-input .docapp-coupon-input--bean-container .docapp-coupon-input--bean-container--bean').each(function() {
                                var text = jQuery(this).text();
                                if (text.match(q)) {
                                    jQuery('.docapp-alert-success').addClass("docapp-hide");
                                    jQuery(this).hide();
                                    jQuery(this).addClass('loyal_point');
                                    jQuery('.docapp-coupon-input input[type=text].docapp-coupon-input--input').css('color', 'black')
                                }
                            })
                        }, 400);
                        setTimeout(function() {
                            jQuery('.docapp-coupon-input .docapp-coupon-input--bean-container .docapp-coupon-input--bean-container--bean').each(function() {
                                var text = jQuery(this).text();
                                if (text.match(q)) {
                                    jQuery('.docapp-alert-success').addClass("docapp-hide");
                                    jQuery(this).hide();
                                    jQuery(this).addClass('loyal_point')
                                }
                            })
                        }, 1000);
                        setTimeout(function() {
                            jQuery('.docapp-coupon-input .docapp-coupon-input--bean-container .docapp-coupon-input--bean-container--bean').each(function() {
                                var text = jQuery(this).text();
                                if (text.match(q)) {
                                    jQuery('.docapp-alert-success').addClass("docapp-hide");
                                    jQuery(this).hide();
                                    jQuery(this).addClass('loyal_point');
                                    jQuery('.docapp-coupon-input--bean-container').show();
                                    jQuery('.docapp-coupon-input input[type=text].docapp-coupon-input--input').css('color', 'black')
                                }
                            })
                        }, 1500);
                        setTimeout(function() {
                            jQuery('.docapp-coupon-input .docapp-coupon-input--bean-container .docapp-coupon-input--bean-container--bean').each(function() {
                                var text = jQuery(this).text();
                                if (text.match(q)) {
                                    jQuery('.docapp-alert-success').addClass("docapp-hide");
                                    jQuery(this).hide();
                                    jQuery(this).addClass('loyal_point');
                                    jQuery('.docapp-coupon-input--bean-container').show();
                                    jQuery('.docapp-coupon-input input[type=text].docapp-coupon-input--input').css('color', 'black')
                                }
                            })
                        }, 2000)
                    } else if (obj.success === !0 && obj.status === !0) {
                        jQuery('.loyal_point .docapp-coupon-input--bean-container--bean-remove').trigger("click");
                        localStorage.removeItem("loyalty");
                        jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[loyalty_mobile_no]=")
                    } else {
                        jQuery('.loyal_point .docapp-coupon-input--bean-container--bean-remove').trigger("click");
                        localStorage.removeItem("loyalty");
                        jQuery.post(window.Shopify.routes.root + 'cart/update.js', "attributes[loyalty_mobile_no]=")
                    }
                }
            })
        }
    }
}
$(document).ready(function() {
    $(document).on('click', '.mm-ajaxcart-open', function(e) {
        e.preventDefault();
        mmajaxcart.AjaxcartOpen();
        mmajaxcart.AjaxcartRender();
        mmajaxcart.Ajaxupsell()
    })
    $(document).on('click', '.mm-ajaxcart-close', function(e) {
        e.preventDefault();
        mmajaxcart.AjaxcartClose()
    });
    $(document).on('click', '.mm-ajaxcart-overlay', function(e) {
        e.preventDefault();
        mmajaxcart.AjaxcartClose()
    });
    mmajaxcart.AjaxcartRender();
    mmajaxcart.AjaxcartRemoveItem();
    mmajaxcart.AjaxcartQuantityHandler();
    mmajaxcart.loyalty_point()
})